module.exports = __webpack_public_path__ + "img/harta-ro.c0ad5724.svg";